import {createContext} from 'react';

const AppContext = createContext();

export const ComponentAContext = createContext();

export default AppContext;